import React, {useEffect, useMemo, useState} from "react";
import PropTypes from 'prop-types';
import {withRouter} from "react-router";
import {DemandValidation, DemandValidationKeys} from 'constants/DemandValidation';
import {connect} from "react-redux";
import Button from "components/Button";
import Tr from 'translations/Translations'
import Typography from "components/Typography";
import GridBlock from "components/GridBlock";
import {makeStyles} from "@material-ui/core";
import Icon from '@material-ui/icons/CheckBox'
import IconOff from '@material-ui/icons/HighlightOff';
import OfferChoiceService from "../../../../../../../services/OfferChoiceService";
import {simpleConfirm} from "../../../../../../../libs/ConfirmNotification";
import LoadingScreen from "../../../../../../../components/complex/loadingScreen/LoadingScreen";
import moment from "../../../../../../../libs/moment";
import DateFormats from "../../../../../../../constants/DateFormats";

const useStyle = makeStyles((theme) => ({
    button: {
        width: 400
    },
    buttonRow: {
        marginTop: theme.spacing(2),
        minWidth: 900
    },
    text: {
        marginTop: theme.spacing(2)
    },
    info: {
        marginBottom: theme.spacing(4)
    },
    icon: theme.components.icon,
}))

function PrimaryTenderChoice(
    {
        match,
        demandValidation
    }) {
    const classes = useStyle();
    const id = match.params.id;
    const curDemandValidation = DemandValidation.PRIMARY_TENDER_CHOICE;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const prevErrors = useMemo(() => demandValidation.filter((x) => x.section !== curDemandValidation && x.status === 'ERROR'), [demandValidation, curDemandValidation]);
    const [working, setWorking] = useState(false)
    const [negotiationButton, setNegotiationButton] = useState(false);
    const [foundExtremelyLowOfferStatus, setFoundExtremelyLowOfferStatus] = useState(false);

    useEffect(() => {
        if (section.choicePending) {
            OfferChoiceService.checkForPrimaryTenderChoiceOptions(id).then(resp => {
                setNegotiationButton(resp.result.showNegotiationPathButton);
                setFoundExtremelyLowOfferStatus(resp.result.extremelyLowOfferStatusFound);
            });
        }
    }, [id, section]);

    const makeNegotiations = () => {
        setWorking(true);
        OfferChoiceService.postPrimaryTenderDoNegotiations(id).catch(() => setWorking(false));
    }

    const skipNegotiations = () => {
        setWorking(true);
        OfferChoiceService.postPrimaryTenderDoOfferChoice(id).catch(() => setWorking(false));
    }

    const hasPrevErrors = prevErrors.length > 0;
    return (section.choicePending ? <GridBlock
                direction='column'
                alignItems='center'
            >
                {
                    hasPrevErrors ?
                        <IconOff className={classes.icon} color='primary'/>
                        :
                        <Icon className={classes.icon} color='primary'/>
                }
                {hasPrevErrors ?
                    <Typography className={classes.info}>{Tr('to_primary_tender_choice_done_sections')}:
                        "{prevErrors.map((x) => Tr(DemandValidationKeys[x.section])).join("\", \"")}"</Typography>
                    :
                    <Typography className={classes.info}>{!!negotiationButton ? Tr('primary_tender_variant_make_choice') : Tr('primary_tender_variant_no_contractors')}</Typography>
                }
                <GridBlock justify="space-between" className={classes.buttonRow}>
                    <Button className={classes.button} disabled={working || hasPrevErrors || !section.editable || !negotiationButton}
                            onClick={() => simpleConfirm(foundExtremelyLowOfferStatus ? "primary_tender_variant_make_negociation_confirm_extremly_low" : "primary_tender_variant_make_negociation_confirm", makeNegotiations)}>
                        {Tr('primary_tender_variant_make_negociation')}
                    </Button>
                    <Button className={classes.button} disabled={working || hasPrevErrors || !section.editable}
                            onClick={() => simpleConfirm("primary_tender_variant_skip_negociation_confirm", skipNegotiations)}>
                        {Tr('primary_tender_variant_skip_negociation')}
                    </Button>
                </GridBlock>
                <LoadingScreen open={working}/>
            </GridBlock>

            :

            <GridBlock
                direction='column'
                alignItems='center'
            >
                <Icon className={classes.icon} color='primary'/>
                <Typography>{Tr('primary_tender_variant_choice_made')}: {!!section.negotiationsCreated ? Tr('primary_tender_variant_make_negociation') : Tr('primary_tender_variant_skip_negociation')}</Typography>

                {!!section.choiceDate && <Typography
                    className={classes.text}>{Tr('primary_tender_variant_choice_made_date')}: {moment(section.choiceDate).format(DateFormats.DATETIME_FORMAT)}</Typography>}
            </GridBlock>
    )
}

PrimaryTenderChoice.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation
}), {})(withRouter(PrimaryTenderChoice));